import axios from 'axios'
import AppHeader from '../AppHeader'

var utils = require('../../utils')
export default {
  name: 'user-new',
  created () {
    this.search()
    if (this.isAppIncluding || this.isAppNotIncluded) {
      this.user.shop_id = window.localStorage.getItem("shop_id")
    }
  },
  data () {
    return {
      canValidate: true,
      userImage: null,
      uploadFlg: false,
      remarkCount: 0,
      userMemoCount: 0,
      age: null,
      user_domain_content_work: null,
      upFlg: false,
      savingFlag: false,
      user: {
        password: null,
        password_confirmation: null,
        user_name: null,
        user_firstname: null,
        user_name_furigana: null,
        user_firstname_furigana: null,
        user_authority: null,
        user_sex: null,
        user_post_no: null,
        user_address: null,
        shop_id: null,
        user_type_id: null,
        email: null,
        user_domain_content: null,
        user_mobile: null,
        user_tel: null,
        user_birthday: new Date("Mon Jan 01 1990 00:00:00 GMT+0900 (JST)"),
        user_joinday: null,
        join_id: null,
        business_type_id : null,
        user_business_type_content: '',
        user_business_type_remarks: null,
        user_memo: null,
        image: null,
        employee_flg: null
      }
    }
  },
  computed: {
    shops: function() {
      return this.$store.getters.userShops
    },
    user_types: function() {
      return this.$store.getters.userTypes
    },
    domains: function() {
      return this.$store.getters.userDomains
    },
    business_types: function() {
      return this.$store.getters.userBusinessTypes
    },
    joins: function() {
      return this.$store.getters.userJoins
    },
    user_birth: function() {
      return this.user.user_birthday ? this.user.user_birthday.getFullYear() + '-' + ("0" + (this.user.user_birthday.getMonth() + 1)).slice(-2) + '-' + ("0" + this.user.user_birthday.getDate()).slice(-2) : ''
    },
    user_join: function() {
      return this.user.user_joinday.getFullYear() + '-' + ("0" + (this.user.user_joinday.getMonth() + 1)).slice(-2) + '-' + ("0" + this.user.user_joinday.getDate()).slice(-2)
    },
    business_content () {
      return this.user.user_business_type_content ? this.user.user_business_type_content.replace(/\r?\n/g, '<br>') : ''
    },
    required: function() {
      return {
        user_post_no: utils.isBlank(this.user.user_post_no),
        user_address: utils.isBlank(this.user.user_address),
        user_post_no_format: !utils.isPostNo(this.user.user_post_no)
      }
    },
    validation: function() {
      var hiragana = /^[\u3040-\u309fー]+$/
      var tel = /^0\d{1,4}-\d{1,4}-\d{3,4}$/
      var number = /^[0-9]+$/
      var email = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]*$/
      var v = {
        user_name: !!this.user.user_name,
        user_firstname: !!this.user.user_firstname,
        user_name_furigana: hiragana.test(this.user.user_name_furigana),
        user_firstname_furigana: hiragana.test(this.user.user_firstname_furigana),
        shop_id: !!this.user.shop_id,
        user_type_id: !!this.user.user_type_id,
        user_authority: !!this.user.user_authority,
        user_birthday: !!this.user.user_birthday,
        user_joinday: !!this.user.user_joinday,
        join_id: !!this.user.join_id,
        user_sex: !!this.user.user_sex,
        user_post_no: !!this.user.user_post_no,
        user_address: !!this.user.user_address,
        user_mobile: tel.test(this.user.user_mobile),
        user_tel: tel.test(this.user.user_tel) || !this.user.user_tel,
        user_email: this.user.email && email.test(this.user.email),
        domain_content: !!this.user.user_domain_content,
        email_domain: !!this.user.email && !!this.user.user_domain_content,

        not_input: !!this.user.user_name &&
                   !!this.user.user_firstname &&
                   hiragana.test(this.user.user_name_furigana) &&
                   hiragana.test(this.user.user_firstname_furigana) &&
                   !!this.user.shop_id &&
                   !!this.user.user_type_id &&
                   !!this.user.user_authority &&
                   !!this.user.user_birthday &&
                   !!this.user.user_joinday &&
                   !!this.user.join_id &&
                   !!this.user.user_sex &&
                   !!this.user.user_post_no &&
                   number.test(this.user.user_post_no) &&
                   !!this.user.user_address &&
                   tel.test(this.user.user_mobile) &&
                   (tel.test(this.user.user_tel) || !this.user.user_tel) &&
                   (this.user.email && email.test(this.user.email)) &&
                   !!this.user.user_domain_content &&
                   !this.uploadError
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    },
    notify () {
      return this.$store.getters.usersNotify
    },
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isAppIncluding () {
      return this.$store.getters.isAppIncluding
    },
    isAppNotIncluded () {
      return this.$store.getters.isAppNotIncluded
    },
    isBrowsIncluding () {
      return this.$store.getters.isBrowsIncluding
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    uploadSuccess() {
      return this.$store.getters.imageUploadSuccess
    },
    uploadError() {
      return this.$store.getters.imageUploadError
    }
  },
  components: {
    AppHeader
  },
  methods: {
    goUserLists: function () {
      this.$router.push({ path: '/users', query: { type: this.$router.currentRoute.query.type}})
    },
    goShopLists: function () {
      this.$router.push({ path: '/shops', query: { type: this.$router.currentRoute.query.type}})
    },
    onClickCancel: function () {
      this.$router.push({ path: '/users', query: { type: this.$router.currentRoute.query.type}})
    },
    onDragOver: function (event) {
      console.log('onDragOver')
      event.preventDefault()
    },
    onDrop: function (event) {
      console.log('onDrop')
      event.preventDefault()
      var files = event.target.files || event.dataTransfer.files
      this.upload(files[0])
    },
    onFileChange: function (event) {
      console.log('onFileChange')
      var files = event.target.files || event.dataTransfer.files
      this.upload(files[0])
    },
    upload: function (file) {
      this.upFlg = true
      var reader = new FileReader()
      var self = this
      reader.onload = (e) => {
        self.user.avartar = e.target.result
        var formData = new FormData()
        formData.append('avartar', file)
        self.$store.dispatch('USER_AVARTAR_UPLOAD', { data: formData, callback: self.onUpload })
      }
      reader.readAsDataURL(file)
    },
    onUpload: function (data) {
      this.userImage = data.image_path + '?token=' + this.authToken
      this.uploadFlg = true
    },
    onClickSave: function () {
      if (this.savingFlag) return false
      var data = {}
      this.user.password = this.user_birth.replace(/-/g,"")
      this.user.password_confirmation = this.user_birth.replace(/-/g,"")
      this.user.user_birthday = this.user_birth
      this.user.user_joinday = this.user_join
      var self = this
      self.canValidate = true
      if (this.isValid) {
        this.savingFlag = true
        console.log("is valid")
        data = self.user
        this.$store.dispatch('USER_CREATE', {data: data, callback: this.onSaved})
      } else {
        console.log("need edit")
      }
    },
    onSaved: function (result) {
      this.savingFlag = false
      this.$router.push('/users')
    },
    search: function() {
      this.$store.dispatch('USER_NEW', {})
    },
    remarkCounter: function() {
      this.half()
      this.remarkCount = this.user.user_business_type_remarks.length
    },
    userMemoCounter: function() {
      this.half()
      this.userMemoCount = this.user.user_memo.length
    },
    selectedUserType: function() {
      var self = this
      self.user.user_business_type_content = ''
      for(var i=0; i < self.$store.getters.userTypes.length; i++){
        var user_type = self.$store.getters.userTypes[i]
        if (user_type.id == self.user.user_type_id) {
          self.user.user_authority = user_type.attributes['default-user-authority']
          self.user.employee_flg = user_type.attributes['employee-flg']
          for(var j=0; j < self.$store.getters.userBusinessTypes.length; j++){
            var business_type = self.$store.getters.userBusinessTypes[j]
            if (business_type.attributes['user-type-id'] == user_type.id) {
              self.user.user_business_type_content = business_type.attributes['business-type-content']
              self.user.business_type_id = business_type.id
              break;
            }
          }
        }
      }
    },
    selectedDomain: function() {
      this.user.user_domain_content = this.user_domain_content_work
    },
    kanaSupport: function () {
      this.half()
      var self = this
      var data = {
        'user_name': self.user.user_name
      }
      var callback = function (){
        self.user.user_name_furigana = self.$store.getters.userNameKana
      }
      this.$store.dispatch('KANA_GET', {data: data, callback: callback})
    },
    kanaFirstSupport: function () {
      this.half()
      var self = this
      var data = {
        'user_name': self.user.user_firstname
      }
      var callback = function (){
        self.user.user_firstname_furigana = self.$store.getters.userNameKana
      }
      this.$store.dispatch('KANA_GET', {data: data, callback: callback})
    },
    calAge: function () {
      if (this.user_birth) {
        var birthday = this.user_birth.replace(/-/g,"")
        var today = new Date()
        var targetdate = today.getFullYear() * 10000 + (today.getMonth() + 1) * 100 + today.getDate()

        this.age = (Math.floor((targetdate - birthday) / 10000))
      } else {
        this.age = null
      }
    },
    onChangePostNo: function () {
      if (this.user.user_post_no) {
        this.user.user_post_no = this.user.user_post_no.replace(/-/g,"")
      }

      if (!!this.user.user_post_no && utils.regex.post_no.test(this.user.user_post_no)) {
        this.$store.dispatch('ADDRESS_GET', {
          postal_code: this.user.user_post_no, callback: (addr) => {
            if (addr) {
              this.user.user_address = addr.address1 + addr.address2
              this.onChangeAddress()
            }
          }
        })
      }
    },
    onChangeAddress: function () {
      this.half()
      var arr = []
      if (utils.isPresent(this.user.user_post_no)) arr.push(this.user.user_post_no)
      if (utils.isPresent(this.user.user_address)) arr.push(this.user.user_address)
      if (arr.length > 0) {
        var address = arr.join(' ')
        if (window.googleMapsQuerySearch) {
          window.googleMapsQuerySearch(address)
        }
      }
    },
    half: function () {
      if (!utils.isBlank(this.user.user_name)) this.user.user_name = utils.emHalf(this.user.user_name)
      if (!utils.isBlank(this.user.user_firstname)) this.user.user_firstname = utils.emHalf(this.user.user_firstname)
      if (!utils.isBlank(this.user.user_address)) this.user.user_address = utils.emHalf(this.user.user_address)
      if (!utils.isBlank(this.user.email)) this.user.email = utils.emHalf(this.user.email)
      if (!utils.isBlank(this.user.user_domain_content)) this.user.user_domain_content = utils.emHalf(this.user.user_domain_content)
      if (!utils.isBlank(this.user.user_business_type_remarks)) this.user.user_business_type_remarks = utils.emHalf(this.user.user_business_type_remarks)
      if (!utils.isBlank(this.user.user_memo)) this.user.user_memo = utils.emHalf(this.user.user_memo)
    },
    /** 画像押下 */
    onClickImageModalShow: function () {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = this.userImage
      text.textContent = ''
      button.click() // モーダル表示 イベント発火
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/user-new.js